import type { FaireProductEntity } from "../../entity_types/product";

export const p_44h74dp64s: FaireProductEntity = {
  token: "p_44h74dp64s",
  type: "product",
  name: "Bulk - Shampoo, Bamboo Bergamot, PRO SIZE",
  brandToken: "b_3938a733",
  brandName: "DANI Naturals",
  imageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/2e27bb3c951f764c0882103b61320be72bd124fb3066a7f5839f6de752f01c3c/1558039705.jpg",
  galleryImageUrls: [],
  priceDollars: 78,
  description:
    "DANI Naturals Pro Line for Professional or Bulk Refill shops only.  Not available for individual resale.\n\nDANI Naturals Sulfate-Free Shampoo features certified organic ingredients and coconut-derived cleansers, making it gentle enough for daily use and safe for all hair types, including color-treated hair. Its low-sudsing formula rinses cleanly, while organic aloe vera and allantoin help to moisturize hair and soothe dry scalps.\n\nUNIQUE PROPERTIES: Intense hydration; Thick & hydrating; Ideal for dry or curly hair\n\nThe Scent:  DANI's Bamboo Bergamot is a crisp, fresh blend of bergamot, cucumber, and melon... clean and spa-like!  This is what FRESH smells like.\n\nPro pump available for sale on our shop page.",
  tags: [],
  msrpDollars: 156,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:07.604Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
